import { createFeatureSelector, createSelector } from "@ngrx/store";
import { AppointmentsState, calendarFeatureKey } from "./calendar.reducers";
import * as fromReducer from "./calendar.reducers";

const selectFeature = createFeatureSelector<AppointmentsState>(
    calendarFeatureKey,
);

export const {
    selectAll: selectAllAppointments,
    selectEntities: selectAppointmentEntities,
} = fromReducer.adapter.getSelectors(selectFeature as any);

export const selectCalendarView = createSelector(
    selectFeature,
    state => state.calendarView
);

export const selectAppointmentById = (id: string) => (state: any) => {
    return selectAppointmentEntities(state)[id];
}

export const selectAllUpcomingLessons = (state: any) => {
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    return selectAllAppointments(state).filter((appointment: any) => {
        return appointment.EndTime > currentDate && (appointment.Type === "Fahrstunde" || appointment.Type === "Prüfung" || appointment.Type === "Probeprüfung")
    });
}

export const selectAllPastLessons = (state: any) => {
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    return selectAllAppointments(state).filter((appointment: any) => {
        return appointment.EndTime < currentDate && (appointment.Type === "Fahrstunde" || appointment.Type === "Prüfung" || appointment.Type === "Probeprüfung")
    });
}

export const selectLessonById = (lessonId: number) => (state: any) => {
    return selectAllAppointments(state).find(lesson => {
        return lesson.Id === lessonId;
    })
}

export const selectUpcomingLessonsByStudentId = (studentId: number) => (state: any) => {
    return selectAllAppointments(state).filter((appointment: any) => {
        return appointment.StudentId === studentId && appointment.StartTime >= new Date();
    });
}

export const selectPastLessonsByStudentId = (studentId: number) => (state: any) => {
    return selectAllAppointments(state).filter((appointment: any) => {
        return appointment.StudentId === studentId && appointment.StartTime < new Date();
    });
}

export const selectExamsByStudentId = (studentId: number) => (state: any) => {
    return selectAllAppointments(state).filter((appointment: any) => {
        return appointment.StudentId === studentId && appointment.Type === "Prüfung";
    });
}

export const selectSelectedLesson = (state: any) => {
    return state[calendarFeatureKey].selectedLesson ? selectAppointmentEntities(state)[state[calendarFeatureKey].selectedLesson] : null;
}

export const selectLessonsByStudentId = (studentId: number) => (state: any) => {
    return selectAllAppointments(state).filter((appointment: any) => {
        return appointment.StudentId === studentId;
    });
}

export const selectPasstLessonsForStudent = (studentId: number, lessonId: number) => (state: any) => {
    return selectAllAppointments(state).filter((appointment: any) => {
        return appointment.StudentId === studentId && appointment.Id !== lessonId && appointment.StartTime < new Date();
    });
}

export const selectUnchargedLessons = (state: any) => {
    return selectAllAppointments(state).filter((appointment: any) => {
        return appointment.InvoiceId === null;
    });
}

export const selectMileageOfLastLesson = (state: any) => {
    // get the last available mileage of any lesson (EndMileage should not be null)
    const lastLesson = selectAllAppointments(state).filter(lesson => lesson.EndMileage !== null).sort((a, b) => b.EndTime?.getTime() - a.EndTime?.getTime())[0];
    return lastLesson?.EndMileage;
}

export const selectIsLoading = createSelector(
    selectFeature,
    state => state.isLoading
);
